import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { IoArrowBack } from 'react-icons/io5';
import './About.css';

export default function About() {
  const navigate = useNavigate();

  return (
    <div className="page about-page">
      <button className="btn btn-ghost" onClick={() => navigate(-1)} style={{ marginBottom: 16 }}>
        <IoArrowBack /> Retour
      </button>

      <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}>
        <h1 className="about-logo">🪶 Plumly</h1>
        <p className="about-tagline">Le Tinder des livres</p>

        <section className="about-section">
          <h2>À propos</h2>
          <p>Plumly est une plateforme de lecture sociale qui révolutionne la découverte littéraire. Découvre ta prochaine lecture en un swipe, lis gratuitement des histoires écrites par une communauté passionnée, et partage tes coups de cœur.</p>
        </section>

        <section className="about-section">
          <h2>Fonctionnalités</h2>
          <p>Swipe pour découvrir, lecteur personnalisable avec 6 thèmes, mode zen, système de followers, messagerie privée, badges, streaks, classements, listes de lecture, commentaires, réactions, et bien plus encore.</p>
        </section>

        <section className="about-section">
          <h2>Conditions d'utilisation</h2>
          <p>En utilisant Plumly, vous acceptez les conditions suivantes :</p>
          <p>Vous êtes responsable du contenu que vous publiez. Tout contenu illégal, haineux, ou portant atteinte aux droits d'auteur sera supprimé. Plumly se réserve le droit de suspendre les comptes ne respectant pas ces règles.</p>
          <p>Les données personnelles sont traitées conformément au RGPD. Vous pouvez demander la suppression de votre compte et de vos données à tout moment.</p>
        </section>

        <section className="about-section">
          <h2>Politique de confidentialité</h2>
          <p>Plumly collecte uniquement les données nécessaires au fonctionnement du service : email, nom d'affichage, préférences de lecture, et contenu publié. Ces données sont stockées de manière sécurisée sur Firebase (Google Cloud) et ne sont jamais vendues à des tiers.</p>
        </section>

        <section className="about-section">
          <h2>Contact</h2>
          <p>Pour toute question, signalement, ou demande de suppression de données, contactez-nous via le système de signalement intégré à l'application.</p>
        </section>

        <div className="about-footer">
          <p>🪶 Plumly — Fait avec passion</p>
          <p>Version 1.0 — 2025</p>
        </div>
      </motion.div>
    </div>
  );
}